import { createBrowserRouter, RouteObject } from 'react-router-dom';
import { MainLayout } from '../Layout/MainLayout';
import { AdminSessionsPage } from '../Pages/AdminSessionsPage';
import { ErrorPage } from '../Pages/ErrorPage';
import HomePage from '../Pages/HomePage';
import { PasswordUpdatePage } from '../Pages/PasswordUpdatePage';
import { SessionsPage } from '../Pages/SessionsPage';
import { SignInPage } from '../Pages/SignInPage';
import { SignUpPage } from '../Pages/SignUpPage';
import { Users } from '../Pages/UsersPage';
import { AdminWrapper } from './AdminWrapper';
import { NotSignedInWrapper } from './NotSignedInWrapper';
import { UserWrapper } from './UserWrapper';

const routes: RouteObject[] = [
    {
        path: '/',
        element: <MainLayout />,
        children: [
            { index: true, element: <HomePage /> },
            {
                path: '/sign-in',
                element: (
                    <NotSignedInWrapper>
                        <SignInPage />
                    </NotSignedInWrapper>
                ),
            },
            {
                path: '/sign-up',
                element: (
                    <AdminWrapper>
                        <SignUpPage />
                    </AdminWrapper>
                ),
            },
            {
                path: '/sessions',
                element: (
                    <UserWrapper>
                        <SessionsPage />
                    </UserWrapper>
                ),
            },
            {
                path: '/password-update',
                element: (
                    <UserWrapper>
                        <PasswordUpdatePage />
                    </UserWrapper>
                ),
            },
            {
                path: '/admin-sessions',
                element: (
                    <AdminWrapper>
                        <AdminSessionsPage />
                    </AdminWrapper>
                ),
            },
            {
                path: '/users',
                element: (
                    <AdminWrapper>
                        <Users />
                    </AdminWrapper>
                ),
            },
        ],
        errorElement: <ErrorPage />,
    },
];

export const router = createBrowserRouter(routes);
